import { useEffect } from "react";
import checkZendesk from "../../hooks/checkZendesk";

const LOCALE = "en-us";

export default function ZendeskInit() {
  useEffect(() => {
    checkZendesk(() => {
      window.zE("messenger:set", "locale", LOCALE);
    });
  }, []);

  return null;
}
